

mp-foreground-text {
  display: block;
  display: flow-root;
  color: var(--color-font-one);

  &:first-child {
    padding-top: var(--page-padding-top);
  }

  &:last-child {
    padding-bottom: var(--page-padding-bottom);
  }

  .section-background-dark & {
    color: var(--color-font-three);
  }

  .mp-foreground-text-copy {
    --image-offset: var(--mp-foreground-text-image-offset, 80px);

    p, ol, ul, blockquote {
      max-width: var(--mp-foreground-text-max-width, 850px);
    }

    strong {
      color: currentColor;
    }

    table {
      width: auto;
      height: auto;
      border: none;

      caption {
        color: var(--color-font-two);
        font-weight: $bold;
        margin-bottom: 1em;
      }

      colgroup {
        col {
          width: 200px !important;
          min-width: 200px;
          min-height: 100px;
        }
      }

      tr {
        td {
          padding: 20px 10px;
          hyphens: auto;
          vertical-align: middle;
          border-bottom: 1px solid white;
          color: var(--color-font-five);
          font-size: 0.8rem;
          font-weight: $semi;

          .is-xl & {
            font-size: 0.7272rem;
          }

          .is-xs & {
            font-size: 0.9rem;
          }
        }
        td:not(:last-child) {
          border-right: 1px solid white;
        }
      }

      thead {
        background-color: var(--color-shadow_one);

        tr {
          td {
            text-align: center;
            color: var(--color-font-two);
            font-weight: $bold;
          }
        }
      }

      tbody {
        tr {
          td:first-child {
            background-color: var(--color-shadow_two);
          }
          td:not(:first-child) {
            text-align: center;
          }
        }
        tr:last-child {
          td {
            border-bottom: none;
          }
        }
      }
    }

    hylo-scrollbar {
      --hylo-margin-x: 0;
      --hylo-margin-y: 0; 
    }

    .hylo-drag-area-wrapper {
      padding-bottom: 20px;
      margin-bottom: 20px;
    }

    hylo-responsive-image {

      img {
        max-width: var(--mp-foreground-text-image-max-width, none);
      }
    }

    hylo-responsive-image:not(.img-is-inline) {
      display: block;
      width: 50%;
      float: right;
      margin: 0 0 1rem 1rem;
      padding: 5px 0 1rem 1rem;

      .is-sm & {
        margin: 0 0 0.5rem 0.5rem;
        padding: 5px 0 0.5rem 0.5rem;
      }

      .is-xs & {
        width: 100%;
        float: none;
        margin: 0;
        padding: 0 0 1rem;
      }

      img {
        width: calc(100% + var(--image-offset));
        max-width: calc((100vw - var(--menu-width)) / 2 - 1rem);

        .is-sm & {
          max-width: calc((100vw - var(--menu-width)) / 2 - 0.5rem);
        }

        .is-xs & {
          width: 100%;
          max-width: 100%;
        }
      }
    }

    hylo-responsive-image.img-is-inline {

      &.img-is-single {
        padding-bottom: 0 !important;
      }

      &.img-full-width {
        width: 100%;
      }

      &.img-align-center {
        width: max-content;
        max-width: 100%;
        margin-left: auto;
        margin-right: auto;
      }
  
      &.img-float-left, &.img-float-right {
        width: 50%;
      }
  
      &.img-float-left {
        float: left;
        padding-right: 22px;
      }
  
      &.img-float-right {
        float: right;
        padding-left: 22px;
      }

      .is-xs &, .is-sm & {
        &.img-full-width, &.img-float-left, &.img-float-right {
          width: 100%;
          float: none;
          padding-left: 0px;
          padding-right: 0px;
        }
      }

    }
  }

  .mp-foreground-text-buttons {
    display: none;
  }

  .mp-foreground-text-headline {
    display: flex;
    align-items: center;
    gap: calc(var(--icon-size) / 3);
    margin-bottom: 2rem;

    --icon-size: 160px;

    .is-lg &, .is-md &, .is-sm & {
      --icon-size: 120px;
    }

    .is-xs & {
      --icon-size: var(--button-width);
    }

    h1 {
      margin-bottom: 0;
      word-break: break-word;
      overflow-wrap: break-word;
    }

    > div {
      display: flex;
      width: var(--icon-size);
      height: var(--icon-size);
      min-width: var(--icon-size);
      min-height: var(--icon-size);
      justify-content: center;
      align-items: center;
      align-self: flex-start;
      border-radius: 99999px;
      border: 2px solid currentColor;
      //transform: translateY(0.5rem);

      .is-xs & {
        transform: none;
      }

      > * {
        width: 100% !important;
        height: 100% !important;
        padding: 22%;
      }
    }
  }

  &.mp-foreground-text-newspaper {

    .mp-foreground-text-copy {
      column-count: 2;
      column-gap: var(--space-default);
      margin-bottom: 1em;

      .is-xs &, .is-sm &, .is-md & {
        column-count: 1;
        margin-bottom: 0;
      }
    }
  }
}
